import card1 from "../assets/lea1.jpg";
import card2 from "../assets/lead2.jpg";
import card3 from "../assets/lead3.jpg";
import card4 from "../assets/lead4.jpg";
import card5 from "../assets/lead5.jpg";
import card6  from "../assets/lead6.jpg";



const leaderboardData = [
  {
    rank: "01.",
    name: "Niriha’s",
    recipe: "Aglio E Olio Maggi",
    score: "28.5/30",
    image: card1,
    top: true,
  },
  {
    rank: "02.",
    name: "Warisha’s",
    recipe: "Peanut Garlic Maggi",
    score: "28/30",
    image: card2,
  },
   {
    rank: "02.",
    name: "Warisha’s",
    recipe: "Peanut Garlic Maggi",
    score: "28/30",
    image: card3,
  },
   {
    rank: "02.",
    name: "Warisha’s",
    recipe: "Peanut Garlic Maggi",
    score: "28/30",
    image: card4,
  },
   {
    rank: "02.",
    name: "Warisha’s",
    recipe: "Peanut Garlic Maggi",
    score: "28/30",
    image: card5,
  },
   {
    rank: "02.",
    name: "Warisha’s",
    recipe: "Peanut Garlic Maggi",
    score: "28/30",
    image: card6,
  },
];

const Leaderboard = () => {
  return (
    <section className="py-24 bg-[#fff9e6]">
      <div className="max-w-5xl mx-auto px-6">

        {/* Header */}
        <div className="bg-[#c98c8f] rounded-xl py-4 mb-6">
          <h2 className="text-center text-3xl font-serif text-white italic">
            leaderboard
          </h2>
        </div>

        {/* Rows */}
        <div className="space-y-4">
          {leaderboardData.map((item, index) => (
            <div
              key={index}
              className="
                relative
                bg-[#b46a6d]
                rounded-xl
                p-4
                flex
                flex-col
                sm:flex-row
                sm:items-center
                gap-4
              "
            >
              {/* LEFT: Image + Rank */}
              <div className="flex items-center gap-4">
                <img
                  src={item.image}
                  alt={item.recipe}
                  className="w-16 h-16 sm:w-20 sm:h-20 rounded-lg object-cover"
                />

                <span className="text-2xl font-serif text-white w-10">
                  {item.rank}
                </span>
              </div>

              {/* CENTER: Name & Recipe */}
              <p className="text-white text-base sm:text-lg flex-1">
                <span className="text-yellow-300 font-semibold">
                  {item.name}
                </span>{" "}
                {item.recipe}
              </p>

              {/* RIGHT: Score */}
              <div
                className="
                  flex
                  items-center
                  gap-2
                  bg-[#a57b94]
                  text-yellow-300
                  px-4
                  py-2
                  rounded-full
                  font-semibold
                  self-start
                  sm:self-auto
                  sm:absolute
                  sm:right-6
                  sm:top-1/2
                  sm:-translate-y-1/2
                "
              >
                {item.top && <span className="text-xl">👑</span>}
                {item.score}
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};


export default Leaderboard;
